import { all, equals, propIs } from 'ramda'
import { get } from './config'

const APP_STORAGE_KEY = 'vicinity.tourism.passport'

const saveUserInStorage = (userData) => {
    console.log('{{ registration.js }} Saving user in Storage', userData)

    const locale = getLocaleFromPath();

    if (locale) {
        userData.locale = locale
    }

    localStorage.setItem(APP_STORAGE_KEY, JSON.stringify(userData))
}

const fetchUserFromStorage = () => {
    const userData = localStorage.getItem(APP_STORAGE_KEY);

    console.log('{{ registration.js }} Fetching user from Storage', userData)

    return (userData && validateUserObject(userData))
        ? JSON.parse(userData)
        : false
}

const validateUserObject = (userData) => {

    console.log('{{ registration.js }} Validating user data from Storage', userData)

    try {
        userData = JSON.parse(userData);
    } catch (e) {
        return false;
    }

    const requiredFields = ['userId', 'locale', 'registrationId']

    return all(equals(true))(
        requiredFields.map((field) => (propIs(String, field, userData)))
    )
}

const getFromPath = (parameter) => {
    let params = new URLSearchParams(document.location.search);
    return params.get(parameter)
}

const getHashFromPath = () => getFromPath('hash')
const getLocaleFromPath = () => getFromPath('locale')

const validateUrl = () => {
    const userData = fetchUserFromStorage();

    if (userData) {
        return Promise.resolve(userData)
    }

    return fetch(`${get('registrationApiUrl')}/registration/validate`, {
        method: 'POST',
        body: JSON.stringify({
            "hash": getHashFromPath(),
            'centre_id': get('centreId')
        })
    })
        .then((response) => response.json())
}

const login = (userData) => {
    if (!userData) {
        return Promise.reject('No user object found')
    }

    return fetch(`${get('registrationApiUrl')}/registration/login`, {
        method: 'POST',
        body: JSON.stringify({
            'registrationId': userData.registrationId,
            'centreId': get('centreId')
        })
    })
        .then((response) => response.json())
        .then((response) => {
            if (!response.valid) {
                throw new Error('User invalid')
            }

            return userData;
        })
}

export { fetchUserFromStorage, login, validateUrl, saveUserInStorage, validateUserObject }



// WEBPACK FOOTER //
// ./lib/registration.js